<template>
  <div id="app" :class="className" @click="isDo">
    <router-view v-if="isRouterAlive" />
  </div>
</template>
<script>
import router from './router';
let Base64 = require('js-base64').Base64
export default {
  name: "app",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      className: "",
      timer: null, //定时器
      lastTime: null, //第一次点击事件
      cTime: null, //当前点击事件
      timeOut: 30 * 60 * 1000, // 设置超时时间：30分钟
      quitTIme: null,
      IsMobile:'',
//    keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    };
  },
  created() {
    this.lastTime = new Date().getTime(); // 网页第一次打开时，记录当前时间

  },
  mounted() {
    this.init();
    this.quitTIme = window.setInterval(this.testTime, 1000);
    
   
    let sUserAgent = navigator.userAgent.toLowerCase();
    let bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
    let bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
    let bIsMidp = sUserAgent.match(/midp/i) == "midp";
    let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
    let bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
    let bIsAndroid = sUserAgent.match(/android/i) == "android";
    let bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
    let bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
    //跳转语句  
     if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
        //跳转移动端页面
        // console.log("手机端页面")
        // this.$store.commit('setMessage',"M");
    } else {
        //跳转pc端页面
        // console.log("pc端页面")
        
        // this.$store.commit('setMessage',"PC");
    } 
    
//  this.IsMobile = this.$store.state.message
//  
//  if(this.IsMobile === 'PC'){
//    this.$router.push({path:'/'})
//  }else{ 
//  	 this.$router.push({path:'/mMain'})
//  }
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    init() {
      // 换肤测试
      import("@/assets/css/color.scss");
      document.body.className = 'theme_default';
      this.timingRemove();

    },
    /**
     * 定时清除提示框的值
     */
    timingRemove() {
      router.afterEach((to, from, next) => {
        var modelPath = to.path
        var modelName = to.meta.title
        //	//进入时间
        to.meta.enterTime = new Date().getTime();
        let onlineTime;
        if (from.meta.enterTime == undefined) {
          from.meta.enterTime = new Date().getTime();
          onlineTime = to.meta.enterTime - from.meta.enterTime
          //        console.log(onlineTime);
        } else {
          onlineTime = to.meta.enterTime - from.meta.enterTime
        }
        if (!isNaN(onlineTime)) {
          setTimeout(() => {
            var Traffic = {
              value: {
                ip: returnCitySN['cip'],
                area: returnCitySN['cname'],
                cookies: this.$cookies.get("ecun"),
                modelPath: modelPath,            
                modelName: Base64.encode(modelName),
                createData: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
                onlineTime: Math.ceil(onlineTime / 1000),
                // onlineTime: "5",
                phonePcFlag:this.$store.state.message
              },
            };
            this.$axios
              .post("/userTrafficStatistics/getUserTrafficStatistics", Traffic)
              .then((res) => {
              })
              .catch((err) => {
              });
          }, 2000)
          // console.log(this.$store.state.message)
        }
        window.scrollTo(0, 0);
      });

    },
    
    // 监听用户操作时间，超过30分钟清除cookie
    isDo() {
      this.cTime = new Date().getTime();
      // console.log(this.cTime - this.lastTime);
      if (this.cTime - this.lastTime > this.timeOut) { //判断上次最后一次的点击时间和最新的点击时间间隔时候大于30分钟
        // 删除cookie
        this.$cookies.remove("ecun");
        // 清除定时器
        window.clearInterval(this.quitTIme);
      } else {
        this.lastTime = new Date().getTime(); //如果30分之内点击，则把最新时间记录覆盖掉之前存的最后一次点击时间
      }
    }
  },
};
</script>
<style lang="scss">
#app {
  width: 100%;
  .g-s-a-w {
    width: 100%;
    min-width: 1440px;
  }
  .g-f-w {
    width: 1440px;
    margin: 0 auto;
  }
  .g-s-index-w {
    width: 100%;
    min-width: 1280px;
  }
  .g-index-w {
    width: 1280px;
    margin: 0 auto;
  }
  
  
}

  /*/deep/.el-carousel__arrow i {
    cursor: pointer;
    margin-top: 146px !important;
}*/

// 正常皮肤
.normal {
}

// 灰色皮肤
.gray {
  img {
    -webkit-filter: grayscale(1);
    /* Webkit */
    filter: gray;
    /* IE6-9 */
    filter: grayscale(1);
    /* W3C */
  }
}

#language-sc {
  font-family: "Source Han Sans", "微软雅黑", "microsoft yahei", "HanHei SC",
    PingHei, "PingFang SC", sans-serif;
  /*font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;*/
}

#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

body {
  overflow-y: scroll !important;
}
/*重新设置高德弹出框样式*/

.amap-info > div:nth-child(2) {
  bottom: 20px !important;
}
// 按钮禁用的灰色
// .buttion_service_font5 {
//   font-size: 14px;
//   font-weight: 400;
//   line-height: 22px;
//   color: rgba(105, 108, 117, 1);
//   width: 100%;
//   text-align: justify;
//   text-justify: inter-ideograph;
//   line-height: 2;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   word-break: break-all;
//   white-space: normal;
//   overflow: hidden;
//   .button_span {
//     background: #004b9c;
//     display: inline-block;
//     padding: 5px 10px;
//     font-size: 14px;
//     line-height: 22px;
//     border-radius: 50px;
//     color: rgba(255, 255, 255, 1);
//   }
// }
/*滚动条 start*/

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: transparent;
}
/*定义滚动条轨道 内阴影+圆角*/

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
  border-radius: 10px;
  background-color: transparent;
}
/*定义滑块 内阴影+圆角*/

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
  /*  background-color: #f5f5f5;*/
  background-color: #999;
}
</style>